module.exports = __webpack_public_path__ + "static/transport-app-cover-0c20ddb378e29cfe4ec8cd592f1f8451.png";